import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import { App, Button, Card, Popconfirm, Space, Spin } from 'antd';
import { CONTRACTOR } from '../../../graphql/queries/contractors';
import { CONTRACTOR_DELETE } from '../../../graphql/mutations/contractors';
import { ContractorInfoCard } from '../../../components/Contractor/ContractorInfoCard';

const ContractorView: React.FC = () => {
  const { id } = useParams();
  const { message } = App.useApp();
  const navigate = useNavigate();

  const { data, loading } = useQuery(CONTRACTOR, {
    variables: { id },
    skip: !id,
  });

  const contractor = data?.contractor;

  const [deleteContractor, { loading: deleting }] = useMutation(CONTRACTOR_DELETE, {
    variables: { id },
    onCompleted: result => {
      if (result?.contractorDelete) {
        message.success('Contractor removed');
        navigate('/admin/contractors');
      } else {
        message.error('Failed to remove contractor');
      }
    },
    onError: error => {
      message.error(error.message || 'Failed to remove contractor');
    },
  });

  if (loading) {
    return <Spin size="large" />;
  }

  if (!contractor) {
    message.error('Contractor not found');
    navigate('/admin/contractors');
    return null;
  }

  return (
    <Card
      title={contractor.name}
      extra={
        <Space>
          <Button
            type="primary"
            onClick={() => navigate(`/admin/contractor/edit/${contractor.id}`)}>
            Edit
          </Button>
          <Popconfirm
            title="Remove contractor?"
            okButtonProps={{ danger: true, loading: deleting }}
            onConfirm={() => deleteContractor()}>
            <Button danger loading={deleting}>
              Delete
            </Button>
          </Popconfirm>
          <Button onClick={() => navigate('/admin/contractors')}>Back to list</Button>
        </Space>
      }>
      <ContractorInfoCard
        contractor={contractor}
        isContractorUser={true}
        onEdit={() => navigate(`/admin/contractor/edit/${contractor.id}`)}
      />
    </Card>
  );
};

export default ContractorView;
